import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { DropdownList } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';

class TimeZonePicker extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	handleSelectChange(timeZoneName) {
		const { onChange } = this.props;

		if (onChange) {
			onChange(timeZoneName);
		}
	}

	renderListItem({ item }) {
		return <div>
			<div style={{ fontSize: '14px' }}>{item.displayName}</div>
			<div>{item.name} (GMT{item.offset})</div>
			<div style={{ color: '#999999' }}>{item.country}</div>
		</div>;
	}

	renderSelectedItem({ item }) {
		return <span>{item.displayName} - {item.name} (GMT{item.offset})</span>;
	}

	render() {
		const { name = 'timeZone', placeholder, timeZones, emptyValue, t, ...rest } = this.props;

		const defaultTimeZoneIfEmpty = timeZones && emptyValue && timeZones.find(x => x.name === emptyValue);
		const placeholderText = placeholder || (defaultTimeZoneIfEmpty && t('TimeZonePicker_Placeholder_UseDefault', { defaultTimeZone: `${defaultTimeZoneIfEmpty.name} (GMT${defaultTimeZoneIfEmpty.offset})` }));

		return <Field name={name} component={DropdownList}
			options={timeZones} valueField='name' textField={item => `${item.displayName} ${item.name} ${item.country} ${item.countryCode}`}	// search in all fields
			filter='contains' clearable
			placeholder={placeholderText}
			//groupBy='countryName'
			itemComponent={this.renderListItem}
			valueComponent={this.renderSelectedItem}
			onChange={this.handleSelectChange}
			{...rest}
		/>;
	}
}

const mapStateToProps = state => {
	const { lookups: { timeZones } } = state;

	return {
		timeZones
	};
};

export default connect(mapStateToProps)(withTranslation()(TimeZonePicker));